<template>
  <div class="header">
    <img class="head" :src="webInfoObj.strPicUrl" alt="" />
    <!-- <div class="menu">
      <ul class="flex container">
        <li>
          <div
            @click="indexHandle()"
            :class="'d0b4db9a744d4507bc5bc66abe331836' == strId ? 'active' : ''"
          >
            <img src="../../assets/images/menu1.png" alt="">
            <span>首页</span>
          </div>
        </li>
        <li v-for="(item, index) in navigations" :key="index">
          <div
            @click="navHandle(item.strId)"
            :class="item.strId == strId ? 'active' : ''"
          >
            <img v-if="item.strName == '会议要闻'" src="../../assets/images/menu2.png" alt="">
            <img v-if="item.strName == '图片新闻'" src="../../assets/images/menu3.png" alt="">
            <img v-if="item.strName == '视频新闻'" src="../../assets/images/menu4.png" alt="">
            <img v-if="item.strName == '大会发言'" src="../../assets/images/menu5.png" alt="">
            <span>{{ item.strName }}</span>
          </div>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import { navData } from "@/api/configuration";
import { get } from "../../utils/helpers";
export default {
  name: "Head",
  components: {},
  data () {
    return {
      strId: "",
      navigations: [],
    };
  },
  props: {
    webInfoObj: {
      type: Object,
      default: () => [],
    },
  },
  watch: {
    $route (to, from) {
      this.strId = this.$route.query.strId;
    },
  },
  created () {
    this.getNavData(); // 获取导航数据
  },
  methods: {
    // 首页跳转
    indexHandle () {
      this.$router.push({ path: "/index", query: { strWebSiteId: this.$route.query.strWebSiteId } });
    },

    // 菜单跳转
    navHandle (strId) {
      this.$router.push({ path: "/list", query: { strId: strId, strWebSiteId: this.$route.query.strWebSiteId } });
    },

    // 获取导航数据
    getNavData () {
      navData({ strWebSiteId: this.$store.state.strWebSiteId })
        .then((res) => {
          this.navigations = get(["data", "navigations"], res.data);
        })
        .catch((err) => {
          this.$message.destroy();
          this.$message.error(err);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  box-sizing: border-box;
  height: 250px;
  .head {
    display: block;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
  .container {
    width: 1280px;
    margin: 0 auto;
  }
  .menu {
    height: 65px;
    line-height: 65px;
    overflow: hidden;
    background: #ce0801;
    li {
      flex: 1;
      overflow: hidden;
      font-size: 26px;
      text-align: center;
      color: #fff;
      display: block;
      cursor: pointer;
      font-weight: bold;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        top: 22px;
        right: 0;
        height: 23px;
        border-right: 1px solid rgba(255, 255, 255, 0.5);
      }
      &:last-child::after {
        display: none;
      }
      span {
        transition: all 0.3s ease-out 0s;
      }
      img {
        vertical-align: middle;
        margin: -5px 10px 0 0;
      }
      // &:hover {
      //   font-size: 20px !important;
      //   font-weight: bold;
      //   background: #d70000;
      // }
      .active {
        font-size: 20px !important;
        font-weight: bold;
        background: #d70000;
      }
    }
  }
}
</style>